export default __webpack_public_path__ + "static/media/dropdown-up.725e1bb2.svg";